<div style="display:show" id="divdata">
    <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
        <h5 class="medium m-0" *ngIf="type == 'ADD'">{{'addOrgUnitType' | translate}} </h5>
        <h5 class="medium m-0" *ngIf="type == 'EDIT'"> {{'edit' | translate}} {{'orgUnitType' | translate}}</h5>
        <h5 class="medium m-0" *ngIf="type == 'DELETE'"> {{'deleteOrganization' | translate}}</h5>
        <div class="ml-alert">
        </div>
        <div style="flex-grow: 1;"></div>
        <button class="btn btn-secondary" name="backOrgUnit" (click)="goToBackPage()">
            <i class="fa fa-arrow-left mr-sm-2"></i> {{'back' | translate}}
        </button>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'code' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input type="text" class="form-control" name="codeOrgUnit" placeholder="{{'code' | translate}}"
                   [(ngModel)]="OrganizationUnitTypeData.orgUnitTypeCode"
                   [readonly]="type == 'DELETE'" maxlength="250">

            <span class="info-text">({{'maxTwoFifty' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'name' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input type="text" class="form-control" name="nameOrgUnit" placeholder="{{'name' | translate}}"
                   [(ngModel)]="OrganizationUnitTypeData.orgUnitTypeName"
                   [readonly]="type == 'DELETE'" maxlength="250">
            <span class="info-text">({{'maxTwoFifty' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'nameLocale' | translate}}

            </label>
            <input type="text" class="form-control" name="nameLocOrgUnit" placeholder="{{'nameLocale' | translate}}"
                   [(ngModel)]="OrganizationUnitTypeData.orgUnitTypeNameLocale"
                   [readonly]="type == 'DELETE'" maxlength="250">
            <span class="info-text">({{'maxTwoFifty' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'description' | translate}}

            </label>
            <input type="text" class="form-control" name="descOrgUnit" placeholder="{{'description' | translate}}"
                   [(ngModel)]="OrganizationUnitTypeData.description"
                   [readonly]="type == 'DELETE'" maxlength="500">
            <span class="info-text">({{'maxFiveHundred' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'descriptionLocale' | translate}}

            </label>
            <input type="text" class="form-control" name="descLocOrgUnit"
                   placeholder="{{'descriptionLocale' | translate}}"
                   [(ngModel)]="OrganizationUnitTypeData.descriptionLocale"
                   [readonly]="type == 'DELETE'" maxlength="500">
            <span class="info-text">({{'maxFiveHundred' | translate}})</span>
        </div>
    </div>

    <div class="col-lg-8 col-md-3 ">
        <div class="form-group">
            <label> {{'level' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input type="number" name="levOrgUnit" class="form-control" placeholder="{{'level' | translate}}"
                   [(ngModel)]="OrganizationUnitTypeData.level" min="1"
                   [readonly]="type == 'DELETE'"
                   onkeypress="return event.charCode >= 48  && event.charCode != 69 && event.charCode != 101"
                   max="100">
        </div>
    </div>

    <div class="col-lg-8 col-md-3">
        <button class="btn btn-primary float-left mt-4" name="saveOrgUnit" *ngIf="type == 'ADD'"
                (click)="saveOrgUnitType()"> {{'add' |
            translate}}
        </button>
        <button class="btn btn-primary float-left mt-4" name="editOrgUnit" *ngIf="type == 'EDIT'"
                (click)="saveOrgUnitType()">
            {{'updateChanges' | translate}}
        </button>
        <button class="btn btn-primary float-left mt-4" name="delOrgUnit" *ngIf="type == 'DELETE'"
                (click)="deleteOrgUnitType()">{{'delete' |
            translate}}
        </button>
        <button class="btn btn-secondary float-left mt-4 ml-1" name="canOrgUnit" (click)="goToBackPage()"> {{'cancel' |
            translate}}
        </button>
    </div>

</div>



// WEBPACK FOOTER //
// ./src/app/tools/organizationUnit/organizationUnit.html